import { render, staticRenderFns } from "./EventLiabilityWidget.vue?vue&type=template&id=6c64787c&"
import script from "./EventLiabilityWidget.ts?vue&type=script&lang=typescript&"
export * from "./EventLiabilityWidget.ts?vue&type=script&lang=typescript&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCardText,VContainer,VSkeletonLoader})
